import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BiSolidDashboard } from "react-icons/bi";
import { FaWallet } from "react-icons/fa";
import { GrServices } from "react-icons/gr";
import { SlSupport } from "react-icons/sl";
import { FaHouseUser } from "react-icons/fa6";
import { MdPeopleAlt } from "react-icons/md";
import { getNavItems } from "../../Routes/AllRoutes";

const iconComponents = {
  dashboard: <BiSolidDashboard size={24} />,
  wallet: <FaWallet size={24} />,
  services: <GrServices size={24} />,
  support: <SlSupport size={24} />,
  users: <FaHouseUser size={24} />,
  agents: <MdPeopleAlt size={24} />,
  "sub-agents": <MdPeopleAlt size={24} />,
};

const SidebarContent = ({ isCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedItem, setSelectedItem] = useState(location.pathname);

  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch (error) {
      console.error("Error parsing user data:", error);
      return null;
    }
  }, []);

  const menuItems = useMemo(() => {
    if (!user) return [];

    return getNavItems(user.role, user.permissions || []).map(({ path, title }) => ({
      path,
      label: title,
      icon: iconComponents[path.replace("/", "")] || <BiSolidDashboard size={24} />,
    }));
  }, [user]);

  useEffect(() => {
    setSelectedItem(location.pathname);
  }, [location.pathname]);

  const isActive = (path) => selectedItem === path;

  return (
    <div>
      {menuItems.map(({ path, label, icon }) => (
        <div
          key={path}
          title={isCollapsed ? label : ""}
          className={`flex items-center mt-2 text-md font-semibold tracking-wide rounded-lg transition-all ease-in-out duration-300 transform cursor-pointer focus:outline-none focus:shadow-outline
            ${isCollapsed ? "justify-center p-3 hover:scale-105" : "px-4 py-3 hover:translate-x-2"}
            ${isActive(path)
              ? "text-white bg-[#2E3A8C]"
              : "text-[#49608c] hover:text-white hover:bg-[#4F68A4]"}`}
          onClick={() => navigate(path)}
        >
          {icon}
          {!isCollapsed && <span className="ml-2 whitespace-nowrap">{label}</span>}
        </div>
      ))}
    </div>
  );
};

export default SidebarContent;
